import React, { useEffect } from 'react';
import { useNavigate, useSearchParams, Link } from 'react-router-dom';
import { CheckCircle, Package, Home, ShoppingBag, ArrowRight } from 'lucide-react';

const OrderSuccessPage = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const orderNumber = searchParams.get('order_number');

  useEffect(() => {
    // Redirect if no order number
    if (!orderNumber) {
      navigate('/');
    }
  }, [orderNumber, navigate]);

  if (!orderNumber) {
    return null;
  }

  return (
    <div className="min-h-screen bg-gray-50 py-12">
      <div className="max-w-2xl mx-auto px-4">
        
        {/* Success Card */}
        <div className="bg-white rounded-2xl shadow-lg p-8 text-center">
          
          {/* Success Icon */}
          <div className="mb-6">
            <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mx-auto">
              <CheckCircle className="w-12 h-12 text-green-600" />
            </div>
          </div>
          
          {/* Success Message */}
          <h1 className="text-3xl font-black text-gray-900 mb-2">
            Order Placed Successfully!
          </h1>
          <p className="text-gray-600 mb-6">
            Thank you for your purchase. Your order has been confirmed.
          </p>
          
          {/* Order Number */}
          <div className="bg-gray-50 rounded-lg p-4 mb-8">
            <p className="text-sm text-gray-600 mb-1">Order Number</p>
            <p className="text-2xl font-bold text-orange-600">{orderNumber}</p>
          </div>
          
          {/* Info Message */}
          <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-8 text-left">
            <div className="flex gap-3">
              <Package className="w-5 h-5 text-blue-600 shrink-0 mt-0.5" />
              <div className="flex-1">
                <h3 className="font-bold text-blue-900 mb-1">What's Next?</h3>
                <ul className="text-sm text-blue-800 space-y-1">
                  <li>• You'll receive an order confirmation email shortly</li>
                  <li>• We'll notify you when your order is shipped</li>
                  <li>• Track your order anytime from your account</li>
                </ul>
              </div>
            </div>
          </div>
          
          {/* Action Buttons */}
          <div className="flex flex-col sm:flex-row gap-3">
            <Link
              to={`/orders/${orderNumber}`}
              className="flex-1 py-3 bg-orange-600 hover:bg-orange-700 text-white font-bold rounded-lg transition-colors flex items-center justify-center gap-2"
            >
              <Package className="w-5 h-5" />
              View Order Details
            </Link>
            <Link
              to="/"
              className="flex-1 py-3 border-2 border-gray-300 text-gray-700 hover:bg-gray-50 font-bold rounded-lg transition-colors flex items-center justify-center gap-2"
            >
              <ShoppingBag className="w-5 h-5" />
              Continue Shopping
            </Link>
          </div>
        </div>
        
        {/* Additional Actions */}
        <div className="mt-6 text-center">
          <Link
            to="/orders"
            className="inline-flex items-center gap-2 text-orange-600 hover:text-orange-700 font-semibold text-sm"
          >
            View All Orders
            <ArrowRight className="w-4 h-4" />
          </Link>
        </div>
        
      </div>
    </div>
  );
};

export default OrderSuccessPage;
